<template>
  <div class="help_box flex" ref="multipleTable">
    <div class="item">
      <span class="txt" style="margin-left:3%">总数量：</span>
      <el-input v-model="fromData.orderQuantityTotal" placeholder="请输入总数量" type="number" onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"></el-input>
      <!-- <el-input v-model="fromData.entryUnitDesc" placeholder="计量单位" style="width:20%;margin-left:5%"></el-input> -->
      <el-select v-model="fromData.unitDesc" @change="changeTargetUnit" :placeholder="this.fromData.entryUnitDesc" style="width:25%;margin-left:5%">
        <el-option
          v-for="item in targetUnitList"
          :label="item.value"
          :key="item.unitDesc"
          :value="item.unitDesc"
        ></el-option>
      </el-select>
    </div>

    <div class="item">
      <span class="txt" style="width:19%;margin-left:2%">报废部分：</span>
      <el-input v-model="fromData.orderConfirmScrap" @change="ConfirmScrapChange" placeholder="请输入报废数量" type="number" onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''" ></el-input>
      <el-input v-model="fromData.batchCharacter" placeholder="" style="width:30%;margin-left:5%" :disabled="true">
          <template slot="append" >%</template>
      </el-input>
    </div>

    <div class="item">
      <span class="txt">已交货：</span>
      <el-input v-model="fromData.deliveryQty" @change="deliveryQtyChange" placeholder="请输入已交货数量" type="number" onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"></el-input>
    </div>

    <div class="item">
      <span class="txt">缺量/过量收货：</span>
      <el-input v-model="fromData.nachl" placeholder="暂无" :disabled="true" type="number" onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"></el-input>
    </div>

    <!-- <div class="item">
    <span class="txt">基本日期：</span>
      <el-date-picker
        v-model="fromData.basicDate"
        type="daterange"
        :clearable=false 
        :editable=false
        range-separator="至"
        start-placeholder="基本开始日期"
        end-placeholder="基本结束日期">
      </el-date-picker>
    </div> -->
    <div class="item">
      <span class="txt">基本开始日期：</span>
      <el-date-picker v-model="fromData.orderStartDate" type="date" placeholder="选择日期"></el-date-picker>
    </div>

    <div class="item">
      <span class="txt">确认开始日期：</span>
      <el-date-picker v-model="fromData.actualStartDate" type="date" placeholder="选择日期"></el-date-picker>
    </div>

    <!-- <div class="item">
    <span class="txt">确定日期：</span>

      <el-date-picker
        v-model="fromData.determineCompleteDate"
        type="daterange"
        :clearable=false 
        :editable=false
        range-separator="至"
        start-placeholder="确定开始日期"
        end-placeholder="确定结束日期">
      </el-date-picker>
    </div> -->

    <div class="item">
      <span class="txt">基本结束日期：</span>
      <el-date-picker v-model="fromData.basicCompletionDate" type="date" placeholder="选择日期"></el-date-picker>
    </div>

    <div class="item">
      <span class="txt">确认结束日期：</span>
      <el-date-picker v-model="fromData.determineCompleteDate" type="date" placeholder="选择日期"></el-date-picker>
    </div>

    <div class="item">
      <span class="txt">确认审批日期：</span>
      <el-date-picker v-model="fromData.actualReleaseDate" type="date" placeholder="选择日期"></el-date-picker>
    </div>

   
  </div>
</template>

<script>
import { fstockApi, customerApi, matterApi } from "api/base.js";
import { targetUnit } from "api/business.js";
import { mapState, mapActions } from "vuex";

export default {
  components: {},
  props: {
    noFromData: Object,
    factoryList: Array,
    fromData: Object,
    materialList: Array,
    distriChannelList: Array,
    salesPriceList: Array,
    priceUnitList: Array,
    basicUnitList: Array
  },
  data() {
    return {
      targetUnitList:[],
      getAllPage: this.$store.state.getAllPage
    };
  },
  async created() {
    //开始日期和结束日期默认今天
    // let nowData = new Date();
    // let arr = [this.fromData.validStartDate,this.fromData.validEndDate];
    // this.$set(this.fromData, "validDate", arr);
    let targetUnitList = await this.$post(targetUnit.list,this.$store.state.getAllPage);
      console.log(targetUnitList,'8888888888');
      if(targetUnitList.status){
        this.targetUnitList = targetUnitList.data.list;
      }
  },
  computed: {},
  watch: {
    'fromData.orderConfirmScrap': function(val, old) {
      console.log(val);
      if(this.fromData.orderConfirmScrap - this.fromData.orderQuantityTotal >0){
          this.$message.error("报废数量不得大于总数量")
          this.fromData.orderConfirmScrap = ''
      }

      if(this.fromData.orderQuantityTotal && this.fromData.orderQuantityTotal != 0){
          this.fromData.batchCharacter = this.fromData.orderConfirmScrap / this.fromData.orderQuantityTotal * 100
      }else if(this.fromData.orderQuantityTotal == 0){
          this.fromData.batchCharacter = 0
      }else{
          this.$message.error("请先输入总数量")
      }
    },
    'fromData.orderQuantityTotal': function(val, old) {
      console.log(val);
      if(this.fromData.orderConfirmScrap && this.fromData.orderQuantityTotal != 0){
          this.fromData.batchCharacter = this.fromData.orderConfirmScrap / this.fromData.orderQuantityTotal * 100
      }else{
          this.fromData.batchCharacter = 0
      }
    }
  },
  methods: {
    ...mapActions("cache", [
      // "setMaterialList",
      // "setDistriChannelList",
      // "setSalesPriceList",
      // "setPriceUnitList",
      // "setBasicUnitList",
      "setSelectedProductOrderMaterial"
    ]),

    //取消选择
    cancelSelect() {
      this.$refs.multipleTable.cancelSelect();
    },
    ConfirmScrapChange(val){
        console.log(val)
        //已在witch监听处理
        // this.fromData.batchCharacter = val / this.fromData.orderQuantityTotal * 100
    },
    //计量单位修改
    changeTargetUnit(val) {
      let obj = this.targetUnitList.find(v=>v.unitDesc === val);
      if(obj){
        this.fromData.unitId = obj.unitId;
        this.fromData.unitCode = obj.unitCode;
        this.fromData.unitDesc = obj.unitDesc;
      }
      console.log(this.fromData)
    },
    //已交货数量改变
    deliveryQtyChange(val){
      if(val == 0){
        this.fromData.nachl = 0
      }else{
        this.fromData.nachl = this.fromData.orderQuantityTotal - this.fromData.deliveryQty
      }
       
    }    

  }
};
</script>

<style>
</style>
